import { triggerNotification } from '../../utils/NotificationContext';
import axiosIns from '../../utils/http/http';

export const fetchActualTemplateData = async (payload) => {
  const pathV2 = '/tpo/calendarCadence/calendarTemplateTasksList?version=v2';
  try {
    const response = await axiosIns.postRequest(pathV2, payload);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to fetch template data!';
    console.log('TCL: fetchTemplateData -> errorMessage', errorMessage);
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchUserTaskList = async (payload) => {
  const path = 'tpo/calendarCadence/getUserTaskList';
  try {
    const response = await axiosIns.postRequest(path, payload);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to fetch template data!';
    console.log('TCL: fetchUserTaskList -> errorMessage', errorMessage);
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchCalanderExistanceByBU = async (params) => {
  const path = '/tpo/calendarCadence/calendarExistenceByBU';
  try {
    const response = await axiosIns.getRequest(`${path}`, { params });
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to fetch calander existance!';
    console.log('TCL: fetchTemplateData -> errorMessage', errorMessage);
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchComprehensiveViewData = async (payload) => {
  const path = '/tpo/calendarCadence/comprehensiveView';
  try {
    const response = await axiosIns.postRequest(path, payload);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to fetch comprehensive view data!';
    console.log('TCL: fetchTemplateData -> errorMessage', errorMessage);
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};
export const updateTaskDetails = async (payload) => {
  const path = '/tpo/calendarCadence/updateTaskDetails';
  try {
    const response = await axiosIns.postRequest(path, payload);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to fetch comprehensive view data!';
    console.log('TCL: fetchTemplateData -> errorMessage', errorMessage);
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const createSubTask = async (payloadObj, userName, action = null) => {
  const path = `/tpo/calendarCadence/addUpdateSubTask?userName=${userName}`;
  try {
    const response = await axiosIns.postRequest(path, payloadObj);
    triggerNotification(
      action === 'add' ? 'Task Successfully created' : 'Task details updated successfully'
    );
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to Create Task!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const deleteTask = async (taskId, outlookNotifications) => {
  const path = `/tpo/calendarCadence/deleteSubTask?taskId=${taskId}&outlookFlag=${outlookNotifications}`;
  try {
    const response = await axiosIns.deleteRequest(path);
    triggerNotification('Task Successfully Deleted');
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to Delete Task!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const updateAssigneeStatus = async (value, id, stepid, email, obj = {}) => {
  const path = `/tpo/calendarCadence/updateAssigneeStatus?id=${id}&status=${value}&version=v2&taskId=${stepid}&actionUserEmail=${email}`;
  try {
    const response = await axiosIns.postRequest(path, obj);
    triggerNotification('Status Successfully Updated');
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to Update Status !';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const sendTaskReminder = async (payload) => {
  const path = `/tpo/calendarCadence/taskReminder`;
  try {
    const response = await axiosIns.postRequest(path, payload);
    triggerNotification(response);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to Update Status !';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const activateCycle = async (taskId, bu, cycleId, status) => {
  const path = `/tpo/updateCycleStatus?calendarTaskId=${taskId}&businessUnitName=${encodeURIComponent(bu)}&cycleId=${cycleId}&cycleStatus=${status}`;
  try {
    const response = await axiosIns.postRequest(path, {});
    triggerNotification(response);
    return response;
  } catch (error) {
    const errorMessage =
      'Error occurred while updating cycle status. Calendar task status has been reverted';
    triggerNotification(errorMessage, 'success');
    throw error;
  }
};
